import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: '{{percentage}}% Rabatt auf ausgewaehlte Artikel',
  [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: '{{percentage}}% Rabatt auf den Gesamtbestellwert',
  [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Gratisartikel beim Kauf eines weiteren Artikels',
  [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Gratisartikel ab Bestellwert',
  [OFFER_KIND.BOGO_HALF_PRICE]: 'Kaufe eins, erhalte eins zum halben Preis',
  [OFFER_KIND.BOGO]: 'Kaufe eins, erhalte eins gratis',
  [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: '{{amount}} Rabatt auf ausgewaehlte Artikel',
  [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: '{{amount}} Rabatt ab Bestellwert',
};
